module.exports = __webpack_public_path__ + "static/media/gb-nir.cc52b85e.svg";